var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submissions-documents"},[_c('div',{staticClass:"u-container"},[_c('p',{staticClass:"submissions-document__num-results"},[_vm._v(_vm._s(_vm.totalResults)+" result"),(_vm.totalResults > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(_vm._s(_vm.calcResultsShowing()))]),_vm._v(" "),_c('submission-cards')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }